import { createAuthClient } from 'better-auth/react';
import { magicLinkClient, emailOTPClient } from 'better-auth/client/plugins';
import { passkeyClient } from '@better-auth/passkey/client';

// 既存 admin-dashboard と同じ Better Auth API origin / cookie を共有する。
// staging/production では cookie domain `.nt-tokyo.org` が共通なので、
// 旧 admin (admin-2025.nt-tokyo.org) と新 admin (admin.nt-tokyo.org) の
// session は同一。public-site とも SSO する。
export const apiBaseURL = (import.meta.env as { VITE_API_URL?: string }).VITE_API_URL ?? 'http://localhost:8787';

interface SignInResult {
  data?: unknown;
  error?: { code?: string; message?: string; status?: number } | null;
}
interface SessionData {
  user?: {
    id: string;
    email: string;
    emailVerified: boolean;
    name?: string | null;
    image?: string | null;
    role?: string | null;
  };
  session?: {
    id: string;
    userId: string;
    expiresAt: Date | string;
    token: string;
  };
}
interface PasskeyRow {
  id: string;
  name?: string | null;
  deviceType?: string;
  createdAt?: string | Date;
}
interface AuthClientSurface {
  useSession: () => {
    data: SessionData | null;
    isPending: boolean;
    error: unknown;
    refetch: () => void;
  };
  useListPasskeys: () => {
    data: PasskeyRow[] | null;
    isPending: boolean;
    error: unknown;
    refetch: () => void;
  };
  signIn: {
    magicLink: (args: { email: string; callbackURL?: string }) => Promise<SignInResult>;
    // 6 桁 OTP コードでのログイン。送信は signIn.magicLink が兼ねる (メールにリンクとコードを併記)。
    emailOtp: (args: { email: string; otp: string }) => Promise<SignInResult>;
    passkey: (args?: { autoFill?: boolean }) => Promise<SignInResult>;
  };
  passkey: {
    addPasskey: (args?: { name?: string }) => Promise<{ data?: unknown; error?: { message?: string } | null }>;
    deletePasskey: (args: { id: string }) => Promise<{ data?: unknown; error?: { message?: string } | null }>;
  };
  signOut: () => Promise<unknown>;
  $fetch: (path: string, init?: RequestInit) => Promise<Response>;
}

const _rawClient = createAuthClient({
  baseURL: apiBaseURL,
  plugins: [magicLinkClient(), emailOTPClient(), passkeyClient()],
});

export const authClient = _rawClient as unknown as AuthClientSurface;
export const useSession = authClient.useSession;
export const signIn = authClient.signIn;
export const signOut = authClient.signOut;
